export const isChromeBrowser = (): boolean => {
    if (typeof window === "undefined" || !window.navigator) {
        return false;
    }

    const { userAgent, vendor } = window.navigator;
    const isChromium = /Chrome/.test(userAgent) && /Google Inc/.test(vendor ?? "");
    const isEdge = /Edg\//.test(userAgent);
    const isOpera = /OPR\//.test(userAgent);
    const isBrave = "brave" in window.navigator;

    return isChromium && !isEdge && !isOpera && !isBrave;
};
